import partition from "lodash-es/partition";
function isActivationRef(item) {
  return item.externalId != null && (!("_populated" in item) || !item._populated);
}
class BaseActivationPopulator {
  async populate(items) {
    const [toBePopulated, others] = partition(items, (i) => isActivationRef(i));
    const populated = await this.populateRefs(toBePopulated);
    return [...populated, ...others];
  }
}
class ApiActivationPopulator extends BaseActivationPopulator {
  constructor(sourceApiBase, sourceVersion = "0.65.0") {
    super();
    this.sourceApiBase = sourceApiBase;
    this.sourceVersion = sourceVersion;
  }
  async populateRefs(items) {
    if (items == null || items.length === 0)
      return [];
    const url = new URL(`${this.sourceApiBase}/activations/populate`);
    url.searchParams.append("sourceVersion", this.sourceVersion);
    const response = await fetch(url.toString(), { method: "POST", body: JSON.stringify(items), headers: { "Content-Type": "application/json" } });
    return await response.json();
  }
}
export {
  ApiActivationPopulator
};
